import * as React from 'react'

export const VisuallyHidden = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
    ({ className = '', children, ...props }, ref) => (
        <span
            ref={ref}
            className={`sr-only ${className}`.trim()}
            {...props}
        >
            {children}
        </span>
    )
)
VisuallyHidden.displayName = 'VisuallyHidden'
